// extracted by css-extract-rspack-plugin
export default {"aiBox":"ai-box_aiBox__Q801+","aiBoxInner":"ai-box_aiBoxInner__XBZTv","withHeaderRow":"ai-box_withHeaderRow__jqTSK"};